var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-color-sec inline-block",attrs:{"disabled":_vm.condition || _vm.disabled}},[(_vm.condition)?_c('spinner-anim'):_vm._e(),_vm._v(" "),_c('span',{class:{ transparent: _vm.condition }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }